import { DownloadOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';

import { useTheme } from '@/theme';

interface DownloadButtonProps {
  label: string;
  onDownload: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

const DownloadButton = (props: DownloadButtonProps) => {
  const theme = useTheme();
  return (
    <Button
      variant='outlined'
      onClick={props.onDownload}
      data-testid='download-template-button'
      role='button'
      startIcon={<DownloadOutlined />}
      sx={{
        borderColor: theme.hhglobal.purpose.textStrong,
        height: '36px',
        textTransform: 'none',
        alignSelf: 'flex-end',
        marginLeft: 'auto',
      }}
    >
      {props.label}
    </Button>
  );
};

export default DownloadButton;
